export default function Resume() {
  return (
    <section className="portfolio--section" id="Resume">
      <div className="portfolio--container-box">
        <div className="portfolio--container">
          <p className="sub--title">Resume</p>
          <h2 className="section--heading">My Resume (Updated 2026)</h2>
        </div>

        <a
          href="/resume-2026.pdf"
          download="ChrisChau_Resume_2026.pdf"
          className="btn btn-github"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="20"
            height="20"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
            <polyline points="7,10 12,15 17,10" />
            <line x1="12" y1="15" x2="12" y2="3" />
          </svg>
          Download PDF
        </a>
      </div>

      <div className="resume--embed">
        <iframe
          src="/resume-2026.pdf"
          title="Chris Chau Resume 2026"
          width="100%"
          height="900"
        />
      </div>
    </section>
  );
}
